type Classification = 'ARTICLE' | 'CHART' | 'BRIEF' | 'MONITOR' | 'NOISE' | null;

const COLOURS: Record<string, string> = {
  ARTICLE: '#d94f00',
  CHART:   '#1a6aff',
  BRIEF:   '#6b6b6b',
  MONITOR: '#8e44ad',
  NOISE:   '#bbb',
};

interface Props { classification: Classification }

export function ClassificationBadge({ classification }: Props) {
  if (!classification) return null;
  return (
    <span style={{
      display: 'inline-block',
      background: COLOURS[classification] ?? '#bbb',
      color: '#fff',
      borderRadius: 3,
      padding: '1px 7px',
      fontSize: 11,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    }}>
      {classification}
    </span>
  );
}
